import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  PartTypeListingService,
  partTypeListingSearchService,
} from "../../../services/PartTypeService";
import VendorList from "./PartTypeList";
import useGlobalState from "../../../Context";

const PartType = () => {
  const [partTypeList, setPartTypeList] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [typeList, setTypeList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchPartTypeDetails("name", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPartTypeDetails = async (sortBy, isAsc, searchValue, partCode,paginationObject) => {
    try {
      setLoading(true);
      const requestBody = {
       "pageSize": paginationObject?.pageSize??10,
        "pageNumber": paginationObject?.pageNumber?? 0,
        "sortDirection": isAsc ? "DESC" : "ASC",
        "sortBy": sortBy,
        "name": searchValue ? searchValue.trim() : null,
        "partCode": partCode ? partCode : null,
        "active": loginUserType === "Main Admin" ? 2 : 0,
      };
      const partTypeListingResponse = await PartTypeListingService(requestBody);
      if (partTypeListingResponse.statusCode === 6) {
        if (partTypeListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setPartTypeList([]);//Clearing before storing new data.
        setPartTypeList(partTypeListingResponse.data.content);
        setTotalElements(partTypeListingResponse.data.totalElements);
      } else {
        showNotification("Error", partTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        active: loginUserType === "Main Admin" ? 2 : 0,
        name: searchValue ? searchValue.trim() : null,
        partCode: null
      };
      // setTableLoader(true);
      const response = await PartTypeListingService(requestBody);
      if (response.statusCode === 6) {
        if (isUpdate) {
          setPartTypeList([...partTypeList, ...response.data.content]);
        } else {
          setPartTypeList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const onSearchType = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        active: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortBy: "name",
        sortDirection: "ASC",
      };
      const typeListingResponse = await partTypeListingSearchService(
        requestBody,
        searchValue
      );
      if (typeListingResponse.statusCode === 6) {
        if (typeListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setPartTypeList(typeListingResponse.data.content);
        setTotalElements(typeListingResponse.data.totalElements);
      } else {
        showNotification("Error", typeListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };


  return (
    <VendorList
      totalElements={totalElements}
      partTypeList={partTypeList}
      typeList={typeList}
      fetchPartTypeDetails={fetchPartTypeDetails}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      onSearchType={onSearchType}
      setPartTypeList={setPartTypeList}
      noRecord={noRecord}
    />
  );
};

export default PartType;
